import { t } from '../../i18n.es.js';
import React from 'react';
import { space } from 'styled-system';
import { styled, SvgIcon, Divider } from '@teko/ui';
import { getTrackingData } from '@teko/tracking';
import { Flex } from '../Flex/Flex.es.js';
import { Text } from '../Text/Text.es.js';
import { CustomLink } from '../../Common/CustomLink/CustomLink.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div(space, `
padding: 10px 16px;
display: flex;
justify-content: space-between;
align-items: center;
background: #fff;
`);
const Title = styled(Text)`
  flex: 1;
  line-height: initial;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    onClick,
    hasDivider,
    children,
    targetPath,
    className,
    regionName,
    right
  } = _b, props = __objRest(_b, [
    "title",
    "onClick",
    "hasDivider",
    "children",
    "targetPath",
    "className",
    "regionName",
    "right"
  ]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ React.createElement(Title, __spreadValues({
    marginRight: "8px",
    maxLines: 1
  }, title), children), onClick && /* @__PURE__ */ React.createElement(Flex, __spreadValues({
    alignItems: "center"
  }, getTrackingData({
    isTrackContent: true,
    regionName,
    contentName: "viewAllProduct",
    target: regionName
  })), /* @__PURE__ */ React.createElement(Text, __spreadValues({
    color: "#848788",
    onClick
  }, right), t("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({
    name: "chevron-forward",
    size: 16,
    color: "#848788"
  }, right))), targetPath && /* @__PURE__ */ React.createElement(CustomLink, {
    targetPath
  }, /* @__PURE__ */ React.createElement(Flex, __spreadValues({
    alignItems: "center"
  }, getTrackingData({
    isTrackContent: true,
    regionName,
    contentName: "viewAllProduct",
    target: regionName
  })), /* @__PURE__ */ React.createElement(Text, __spreadValues({
    color: "#848788"
  }, right), t("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({
    name: "chevron-forward",
    size: 16,
    color: "#848788"
  }, right))))), hasDivider && /* @__PURE__ */ React.createElement(Divider, null));
};

export { BlockHeader };
